export default "__VITE_ASSET__DdIwOVU8__"